import { render, staticRenderFns } from "./RcpyL_List.vue?vue&type=template&id=70478e44"
import script from "./RcpyL_List.vue?vue&type=script&lang=js"
export * from "./RcpyL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports